/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import AvatarUser from '../../../../frontend/views/components/AvatarUser.vue'
import ProfileCard from '../../../../frontend/views/components/ProfileCard.vue'
import { mapGetters } from 'vuex'
import { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'
import { CLOSE_NAVIGATION_SIDEBAR } from '../../../../frontend/utils/events.js'

const __vue_script__ = ({
  name: 'Profile',
  components: {
    AvatarUser,
    ProfileCard
  },
  computed: {
    ...mapGetters([
      'ourUsername',
      'ourIdentityContractId'
    ]),
    ourDisplayName () {
      const userContract = this.$store.getters.currentIdentityState
      return userContract && userContract.attributes && userContract.attributes.displayName
    }
  },
  methods: {
    toUserSettings () {
      sbp('okTurtles.events/emit', CLOSE_NAVIGATION_SIDEBAR)
      this.$router.push({ name: 'UserSettings' }).catch(logExceptNavigationDuplicated)
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.loggedIn
    ? _c(
        "div",
        { staticClass: "c-profile", attrs: { "data-test": "userProfile" } },
        [
          _c(
            "profile-card",
            {
              attrs: {
                contractID: _vm.ourIdentityContractId,
                direction: "top-left",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "is-unstyled c-avatar-user",
                  attrs: { "data-test": "openProfileCard" },
                },
                [
                  _c("avatar-user", {
                    attrs: {
                      contractID: _vm.ourIdentityContractId,
                      size: "sm",
                    },
                  }),
                  _c("div", { staticClass: "c-user" }, [
                    _c(
                      "strong",
                      {
                        staticClass: "has-ellipsis",
                        attrs: {
                          "data-test": _vm.ourDisplayName
                            ? "profileDisplayName"
                            : "profileName",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.ourDisplayName ||
                              _vm.ourUsername ||
                              _vm.ourIdentityContractId
                          )
                        ),
                      ]
                    ),
                    _vm.ourDisplayName
                      ? _c(
                          "span",
                          {
                            staticClass: "has-ellipsis",
                            attrs: { "data-test": "profileName" },
                          },
                          [_vm._v("@" + _vm._s(_vm.ourUsername))]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "is-icon-small",
              attrs: {
                title: _vm.L("User settings"),
                "data-test": "settingsBtn",
              },
              on: { click: _vm.toUserSettings },
            },
            [_c("i", { staticClass: "icon-cog" })]
          ),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2aa871e0_0", { source: ".c-profile[data-v-2aa871e0] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n  padding: 0 1rem;\n}\n.c-avatar-user[data-v-2aa871e0] {\n  display: flex;\n  align-items: center;\n}\n.c-avatar-user:focus .c-user strong[data-v-2aa871e0], .c-avatar-user:hover .c-user strong[data-v-2aa871e0] {\n  border-bottom-color: var(--text_0);\n}\n.c-user[data-v-2aa871e0] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 0.5rem;\n  max-width: 7rem;\n  white-space: nowrap;\n  line-height: 1.3;\n  margin-top: 1px;\n}\n.c-user strong[data-v-2aa871e0] {\n  border-bottom: 1px solid transparent;\n  width: 100%;\n}\n.c-user span[data-v-2aa871e0] {\n  font-family: \"Lato\";\n  color: var(--text_1);\n  width: 100%;\n}\nbutton .icon-cog[data-v-2aa871e0] {\n  font-size: 0.875rem;\n  transform-origin: 49% 48%;\n}\nbutton:hover .icon-cog[data-v-2aa871e0], button:focus .icon-cog[data-v-2aa871e0] {\n  animation: cog-data-v-2aa871e0 400ms forwards;\n}\n@keyframes cog-data-v-2aa871e0 {\nto {\n    transform: rotate(180deg);\n}\n}\n\n/*# sourceMappingURL=Profile.vue.map */", map: {"version":3,"sources":["frontend/views/containers/navigation/Profile.vue","Profile.vue"],"names":[],"mappings":"AA8DA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AC7DA;ADgEA;EACA,aAAA;EACA,mBAAA;AC7DA;ADiEA;EACA,kCAAA;AC/DA;ADoEA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;ACjEA;ADmEA;EACA,oCAAA;EACA,WAAA;ACjEA;ADoEA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;AClEA;ADuEA;EACA,mBAAA;EACA,yBAAA;ACpEA;ADuEA;EAEA,6CAAA;ACtEA;AD0EA;AACA;IAAA,yBAAA;ACtEE;AACF;;AAEA,sCAAsC","file":"Profile.vue","sourcesContent":["<template lang='pug'>\n.c-profile(\n  v-if='$store.state.loggedIn'\n  data-test='userProfile'\n)\n  profile-card(:contractID='ourIdentityContractId' direction='top-left')\n    button.is-unstyled.c-avatar-user(data-test='openProfileCard')\n      avatar-user(:contractID='ourIdentityContractId' size='sm')\n      .c-user\n        strong.has-ellipsis(\n          :data-test='ourDisplayName ? \"profileDisplayName\" : \"profileName\"'\n        ) {{ ourDisplayName || ourUsername || ourIdentityContractId }}\n\n        span.has-ellipsis(\n          data-test='profileName'\n          v-if='ourDisplayName'\n        ) @{{ ourUsername }}\n\n  button.is-icon-small(\n    :title='L(\"User settings\")'\n    data-test='settingsBtn'\n    @click='toUserSettings'\n  )\n    i.icon-cog\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport AvatarUser from '../../../../frontend/views/components/AvatarUser.vue'\nimport ProfileCard from '../../../../frontend/views/components/ProfileCard.vue'\nimport { mapGetters } from 'vuex'\nimport { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'\nimport { CLOSE_NAVIGATION_SIDEBAR } from '../../../../frontend/utils/events.js'\n\nexport default ({\n  name: 'Profile',\n  components: {\n    AvatarUser,\n    ProfileCard\n  },\n  computed: {\n    ...mapGetters([\n      'ourUsername',\n      'ourIdentityContractId'\n    ]),\n    ourDisplayName () {\n      const userContract = this.$store.getters.currentIdentityState\n      return userContract && userContract.attributes && userContract.attributes.displayName\n    }\n  },\n  methods: {\n    toUserSettings () {\n      sbp('okTurtles.events/emit', CLOSE_NAVIGATION_SIDEBAR)\n      this.$router.push({ name: 'UserSettings' }).catch(logExceptNavigationDuplicated)\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n  padding: 0 1rem;\n}\n\n.c-avatar-user {\n  display: flex;\n  align-items: center;\n\n  &:focus,\n  &:hover {\n    .c-user strong {\n      border-bottom-color: $text_0;\n    }\n  }\n}\n\n.c-user {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 0.5rem;\n  max-width: 7rem;\n  white-space: nowrap;\n  line-height: 1.3;\n  margin-top: 1px;\n\n  strong {\n    border-bottom: 1px solid transparent;\n    width: 100%;\n  }\n\n  span {\n    font-family: \"Lato\";\n    color: $text_1;\n    width: 100%;\n  }\n}\n\nbutton {\n  .icon-cog {\n    font-size: $size_4;\n    transform-origin: 49% 48%;\n  }\n\n  &:hover .icon-cog,\n  &:focus .icon-cog {\n    animation: cog 400ms forwards;\n  }\n}\n\n@keyframes cog {\n  to { transform: rotate(180deg); }\n}\n</style>\n",".c-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n  padding: 0 1rem;\n}\n\n.c-avatar-user {\n  display: flex;\n  align-items: center;\n}\n.c-avatar-user:focus .c-user strong, .c-avatar-user:hover .c-user strong {\n  border-bottom-color: var(--text_0);\n}\n\n.c-user {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 0.5rem;\n  max-width: 7rem;\n  white-space: nowrap;\n  line-height: 1.3;\n  margin-top: 1px;\n}\n.c-user strong {\n  border-bottom: 1px solid transparent;\n  width: 100%;\n}\n.c-user span {\n  font-family: \"Lato\";\n  color: var(--text_1);\n  width: 100%;\n}\n\nbutton .icon-cog {\n  font-size: 0.875rem;\n  transform-origin: 49% 48%;\n}\nbutton:hover .icon-cog, button:focus .icon-cog {\n  animation: cog 400ms forwards;\n}\n\n@keyframes cog {\n  to {\n    transform: rotate(180deg);\n  }\n}\n\n/*# sourceMappingURL=Profile.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-2aa871e0"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n.c-profile(\n  v-if='$store.state.loggedIn'\n  data-test='userProfile'\n)\n  profile-card(:contractID='ourIdentityContractId' direction='top-left')\n    button.is-unstyled.c-avatar-user(data-test='openProfileCard')\n      avatar-user(:contractID='ourIdentityContractId' size='sm')\n      .c-user\n        strong.has-ellipsis(\n          :data-test='ourDisplayName ? \"profileDisplayName\" : \"profileName\"'\n        ) {{ ourDisplayName || ourUsername || ourIdentityContractId }}\n\n        span.has-ellipsis(\n          data-test='profileName'\n          v-if='ourDisplayName'\n        ) @{{ ourUsername }}\n\n  button.is-icon-small(\n    :title='L(\"User settings\")'\n    data-test='settingsBtn'\n    @click='toUserSettings'\n  )\n    i.icon-cog\n</template>\n\n<script>\nimport sbp from '@sbp/sbp'\nimport AvatarUser from '../../../../frontend/views/components/AvatarUser.vue'\nimport ProfileCard from '../../../../frontend/views/components/ProfileCard.vue'\nimport { mapGetters } from 'vuex'\nimport { logExceptNavigationDuplicated } from '../../../../frontend/views/utils/misc.js'\nimport { CLOSE_NAVIGATION_SIDEBAR } from '../../../../frontend/utils/events.js'\n\nexport default ({\n  name: 'Profile',\n  components: {\n    AvatarUser,\n    ProfileCard\n  },\n  computed: {\n    ...mapGetters([\n      'ourUsername',\n      'ourIdentityContractId'\n    ]),\n    ourDisplayName () {\n      const userContract = this.$store.getters.currentIdentityState\n      return userContract && userContract.attributes && userContract.attributes.displayName\n    }\n  },\n  methods: {\n    toUserSettings () {\n      sbp('okTurtles.events/emit', CLOSE_NAVIGATION_SIDEBAR)\n      this.$router.push({ name: 'UserSettings' }).catch(logExceptNavigationDuplicated)\n    }\n  }\n}: Object)\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.c-profile {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 4rem;\n  padding: 0 1rem;\n}\n\n.c-avatar-user {\n  display: flex;\n  align-items: center;\n\n  &:focus,\n  &:hover {\n    .c-user strong {\n      border-bottom-color: $text_0;\n    }\n  }\n}\n\n.c-user {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 0.5rem;\n  max-width: 7rem;\n  white-space: nowrap;\n  line-height: 1.3;\n  margin-top: 1px;\n\n  strong {\n    border-bottom: 1px solid transparent;\n    width: 100%;\n  }\n\n  span {\n    font-family: \"Lato\";\n    color: $text_1;\n    width: 100%;\n  }\n}\n\nbutton {\n  .icon-cog {\n    font-size: $size_4;\n    transform-origin: 49% 48%;\n  }\n\n  &:hover .icon-cog,\n  &:focus .icon-cog {\n    animation: cog 400ms forwards;\n  }\n}\n\n@keyframes cog {\n  to { transform: rotate(180deg); }\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__